import React, { useState } from "react";
import { connect } from "react-redux";
import unauthorizedImg from "../assets/svg/unauthorized.svg";
import Paper from "../components/ui-library/Paper/Paper";
import { mapStateToPropsLogin } from "../modules/login";
import { useEffect } from "react";
import LoadingSpinner from "../components/ui-library/LoadingSpinner/LoadingSpinner";
import { history } from "../modules/history";
import { useTranslation } from "react-i18next";

const Unauthorized = ({ token, setOpenModal }) => {
  const { t } = useTranslation();

  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    setRedirecting(true);
    const timer = setTimeout(() => history.push("/home"), 4000);
    return () => clearTimeout(timer);
  }, [setOpenModal, token]);

  return (
    <div id="content" className="container-fluid">
      <div className="row">
        <Paper header={t("appText.unauthorized.title")}>
          <div
            className="h-100 w-100 d-flex flex-column align-items-center justify-content-around"
            style={{ color: "rgba(0,0,0,0.20)" }}
          >
            <img src={unauthorizedImg} alt="Not Found" height={"300px"} />
            <div style={{ fontSize: "2.5rem" }}>
              {t("appText.unauthorized.message")}
            </div>
            <div>{t("appText.unauthorized.info")}</div>
            {redirecting && <LoadingSpinner />}
          </div>
        </Paper>
      </div>
    </div>
  );
};

export default connect(mapStateToPropsLogin)(Unauthorized);
